import React from "react";
import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";

// Helper component that retrieves history using useHistory() in order
// to avoid creating another layer between the index and App components.
const OktaAuthLayer: React.FC<{ okta: OktaAuth }> = ({ children, okta }) => {
  return (
    <Security
      oktaAuth={okta}
      restoreOriginalUri={() => {
        return;
      }}
    >
      {children}
    </Security>
  );
};

export default OktaAuthLayer;
